import {range} from 'lodash'

export function createPlanSection (section) {
  const {type} = section
  switch (type) {
    case "dropdown": return {...section, value: range(section.count || 1).map(_ => "")}
    case "panel": return {...section, children: section.children.map(createPlanSection)}
    default: return {...section, value: ""}
  }
}

